import { render, staticRenderFns } from "./deleteDistributionMode.vue?vue&type=template&id=23fb4d42"
import script from "./deleteDistributionMode.vue?vue&type=script&lang=js"
export * from "./deleteDistributionMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports